export default __webpack_public_path__ + "static/greenCode-videoMiseEnAvant-c91079d80a1db3d6aaa50e40ca324b20.mp4";